import React, { useEffect, useState } from "react";
import CustomHeader from "../common/Header";
import { Button, Card, Skeleton } from "antd";
import { EditTwoTone, PlusOutlined } from "@ant-design/icons";
import AddEditForm from "./Form";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomTable from "../common/Table";

function Contacts() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [addEditModalVisible, setAddEditModalVisible] = useState(0);
    const [editRecord, setEditRecord] = useState({});
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const [formData, setFormData] = useState({
        page: 0,
        limit: 10,
        sorting: 1,
        sort_by: "updated_at",
    });

    const {
        status: contactStatus,
        data: contactData,
        refetch: getContactDetails,
    } = useQuery(
        "back-office/contacts",
        async () =>
            HTTP("/backOffice/getBackOfficeContacts", {
                ...formData,
                staff_id,
            }),
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getContactDetails();
    }, []);

    useEffect(() => {
        getContactDetails();
    }, [formData]);

    useEffect(() => {
        if (contactStatus == "success") {
            setTableData(contactData.data);
            setTotalRecords(contactData.total);
        }
    }, [contactStatus, contactData]);

    function handleAdd() {
        setAddEditModalVisible(1);
    }

    function handleEdit(record) {
        setEditRecord(record);
        setAddEditModalVisible(2);
    }

    function handleCancel(reload) {
        setAddEditModalVisible(0);
        reload && getContactDetails();
    }

    const columns = [
        {
            title: "Property Name",
            dataIndex: "property_name",
            key: "property_name",
            sorter: () => {},
            width: "10%",
        },
        {
            title: "Company",
            dataIndex: "company_name",
            key: "company_name",
            sorter: () => {},
            width: "10%",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: () => {},
            width: "15%",
        },
        {
            title: "Fax Number",
            dataIndex: "fax_number",
            key: "fax_number",
            sorter: () => {},
            width: "10%",
        },
        {
            title: "Phone",
            dataIndex: "phone_number",
            key: "phone_number",
            width: "10%",
            render: (data) => (
                <ul style={{ padding: 0 }}>
                    {data.map(({ first_name, last_name, number }) => (
                        <li key={number}>{`${first_name || ""} ${
                            last_name || ""
                        } (${number})`}</li>
                    ))}
                </ul>
            ),
        },
        {
            title: "Bussiness Phone",
            dataIndex: "business_phone_number",
            key: "business_phone_number",
            width: "10%",
            render: (data) => (
                <ul style={{ padding: 0 }}>
                    {data.map(({ first_name, last_name, number }) => (
                        <li key={number}>{`${first_name || ""} ${
                            last_name || ""
                        } (${number})`}</li>
                    ))}
                </ul>
            ),
        },
        {
            title: "Account Phone",
            dataIndex: "account_phone_number",
            key: "account_phone_number",
            width: "10%",
            render: (data) => (
                <ul style={{ padding: 0 }}>
                    {data.map(({ first_name, last_name, number }) => (
                        <li key={number}>{`${first_name || ""} ${
                            last_name || ""
                        } (${number})`}</li>
                    ))}
                </ul>
            ),
        },
        {
            title: "Mobile Phone",
            dataIndex: "mobile_number",
            key: "mobile_number",
            width: "10%",
            render: (data) => (
                <ul style={{ padding: 0 }}>
                    {data.map(({ first_name, last_name, number }) => (
                        <li key={number}>{`${first_name || ""} ${
                            last_name || ""
                        } (${number})`}</li>
                    ))}
                </ul>
            ),
        },
        {
            title: "Notes",
            dataIndex: "notes",
            key: "notes",
            sorter: () => {},
            width: "10%",
        },
        {
            title: "Actions",
            render: (_, record) => (
                <EditTwoTone onClick={() => handleEdit(record)} />
            ),
            width: "10%",
        },
    ];

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        <div>
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={handleAdd}
                            >
                                <PlusOutlined /> Add
                            </Button>
                        </div>
                    }
                />
                {contactStatus !== "idle" && contactStatus !== "loading" ? (
                    <CustomTable
                        handleTableChange={handleTableChange}
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        rowKey="id"
                    />
                ) : (
                    <Skeleton active title={false} paragraph={{ rows: 40 }} />
                )}
            </Card>

            {addEditModalVisible == 0 ? (
                <></>
            ) : addEditModalVisible == 1 ? (
                <AddEditForm handleCancel={handleCancel} />
            ) : (
                <AddEditForm
                    handleCancel={handleCancel}
                    editRecord={editRecord}
                />
            )}
        </>
    );
}

export { Contacts };
